module.exports = __webpack_public_path__ + "img/Brand_learning_three.4d9374af.png";